import { render } from "./About.vue?vue&type=template&id=0c2b31ba&scoped=true&bindings={}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0c2b31ba&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0c2b31ba"

export default script